import { useTrans } from '@/shared/hooks/useTranslation';
import { getSupportTicketFields } from '@/view/features/support/supportTicketFields';
import { DynamicForm } from '@/view/shared/form';
import { type SupportTicketView, useSupportTicketViewModel } from '@/viewmodel/features/support';
import { useDynamicFormViewModel } from '@/viewmodel/shared/form';

interface SupportTicketFormProps {
  onSuccess: (ticket: SupportTicketView) => void;
}

export function SupportTicketForm({ onSuccess }: Readonly<SupportTicketFormProps>) {
  const { t } = useTrans();
  const { submit, isSubmitting } = useSupportTicketViewModel(onSuccess);
  const form = useDynamicFormViewModel({ fields: getSupportTicketFields(t), onSubmit: submit });

  return (
    <DynamicForm
      form={form}
      submitButtonText={t('support.form.submit')}
      isSubmitting={isSubmitting}
    />
  );
}
